// extracted by mini-css-extract-plugin
module.exports = {"root":"Info-root-996923fe659288e5cfc095813fdb3eec"};